import './axios'
import './fontawesome'
import './vuelidate'
import './uiplugins'
import './wait'
import './api_query'
import './clipboard'
import './moment'
import './cookie'
